// Ported from mantis-business-front-brinks's estado-badge.tsx, onto the real 3-tone mapping in
// `utils/cierrePanel.js` (`estadoDeFila`) instead of the mockup's fixture-derived one.
import { AlertTriangle, Check, Clock, Lock } from "lucide-react";
import { cn } from "@mantis-sas/ui";
import { ETIQUETA_ESTADO } from "../../../utils/cierrePanel";
import "./styles/brinksTheme.css";

// brinks' exact `-soft`/`-border` pair per tone, not mantis-ui's own `success`/`warning`/
// `destructive` (see brinksTheme.css's header for why they're a separate scoped token set).
const ESTILOS = {
  cuadre: "bg-brinks-success-soft text-brinks-success border-brinks-success-border",
  pendiente: "bg-brinks-warning-soft text-brinks-warning border-brinks-warning-border",
  bloqueado: "bg-brinks-danger-soft text-brinks-danger border-brinks-danger-border",
  sinCierre: "bg-brinks-surface text-brinks-muted-foreground border-border",
};

const ICONOS = { cuadre: Check, pendiente: AlertTriangle, bloqueado: Lock, sinCierre: Clock };

export function EstadoBadge({ estado, className }) {
  const Icono = ICONOS[estado] || AlertTriangle;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[12px] font-medium leading-none",
        ESTILOS[estado] || ESTILOS.pendiente,
        className
      )}
    >
      <Icono className="h-3.5 w-3.5 shrink-0" />
      <span className="truncate">{ETIQUETA_ESTADO[estado] || estado || "—"}</span>
    </span>
  );
}

export default EstadoBadge;
